'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dEither from "./scala.util.-Either.js";
var $p;
/** @constructor */
function $c_s_util_Right(value) {
  this.h9 = null;
  this.h9 = value;
}
export { $c_s_util_Right as $c_s_util_Right };
$p = $c_s_util_Right.prototype = new $j_scala$002eutil$002e$002dEither.$h_s_util_Either();
$p.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
}
export { $h_s_util_Right as $h_s_util_Right };
$h_s_util_Right.prototype = $p;
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 252890491, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_s_util_Right) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.h9, x$0.h9)));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "Right";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.h9;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ga)));
}
export { $isArrayOf_s_util_Right as $isArrayOf_s_util_Right };
var $d_s_util_Right = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Right, "scala.util.Right", ({
  ga: 1,
  cH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_s_util_Right as $d_s_util_Right };
